/*=======================Ajax=======================*/
function Ajax(){}
Ajax.showLoading=function(){$('.loader').show();}
Ajax.hideLoading=function(){$('.loader').hide();}
Ajax.prototype.filterAjaxClick=function(baseLink,render,callback){if(Shopify.queryParams){delete Shopify.queryParams.page;}
var newUrl=this.filterCreateUrl(baseLink);history.pushState({param:Shopify.queryParams?Shopify.queryParams:''},newUrl,newUrl);this.loadData(newUrl,render,callback);}
Ajax.prototype.filterCreateUrl=function(baseLink){var newQuery='';if(Shopify.queryParams){newQuery=$.param(Shopify.queryParams).replace(/%2B/g,'+');}
if(baseLink){if(newQuery!="")
return baseLink+"?"+newQuery;else
return baseLink;}
return newQuery.length>0?location.pathname+"?"+newQuery:location.pathname;};Ajax.prototype.loadData=function(url,render,callback){$.ajax({type:'get',url:url,beforeSend:function(){Ajax.showLoading();},success:function(data){render(data,callback);Ajax.hideLoading();},error:function(xhr,text){Ajax.hideLoading();}});}
/*=======================FakeCrop=======================*/
function FakeCrop(){}
FakeCrop.prototype.init=function(items){var selector='.tp-product-grid .grid-item .grid-image img';if(items){var arrayItem=[];items.forEach(function(item){arrayItem.push($(item).find('.grid-image img')[0]);});selector=arrayItem;}
$(selector).fakecrop({fill:false,widthSelectorParent:".grid-item .grid-item-inner .grid-item-image",ratioWrapper:window.images_size});}
/*=======================Image=======================*/
function ImageShopify() {}
ImageShopify.prototype.initAll = function(items) {
    if (items) {
        this.initSwapImage(items);
        this.initColorVariant(items);
    } else {
        this.initSwapImage();
        this.initColorVariant();
    }
    /*this.initSetProductHeight();*/
}
ImageShopify.prototype.initImageConfigure = function(items) {
    var fakecrop = new FakeCrop();
    fakecrop.init(items);
    if ((typeof SCAShopify) !== 'undefined' && $(window).width() >= 768) {
        SCAShopify.jQuery(document).unbind('click.fb-start');
        SCAShopify.jQuery.getScript('//cdn.secomapp.com/quickview/assets/cdn/sca-qv-scripts-noconfig.js');
    }
    this.initAll(items);
    if (window.SPR) {
        window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
    }
    jQuery('.tp-product-item-price').each(function() {
        jQuery(this).html(jQuery(this).html().replace('from', ''));
        jQuery(this).html(jQuery(this).html().replace('From', ''))
    });
}
ImageShopify.prototype.initSwapImage = function(items) {
    var swapInterval;
    var self;
    var selector = ".grid-image.image-swap";
    if (items) {
        var arrayItem = [];
        items.forEach(function(item) {
            arrayItem.push($(item).find('.grid-image.image-swap')[0]);
        });
        selector = arrayItem;
    }
    $(selector).on('mouseenter', function(e) {
        if (!swapInterval) {
            self = this;
            var length = $(this).children().length;
            var index = 1;
            if (length > 1) {
                swapImage(1);
                swapInterval = setInterval(function() {
                    index = index + 1;
                    if (index === length) {
                        index = 0;
                    }
                    swapImage(index);
                }, 1000);

                function swapImage(index) {
                    $(self).children('img').each(function(i, e) {
                        if (i === index) {
                            this.style.display = 'inline-block';
                        } else {
                            this.style.display = 'none';
                        }
                    });
                }
            }
        }
    }).on('mouseleave', function(e) {
        if (e.toElement) {
            switch (e.toElement.className) {
                case 'label-sale':
                    return;
                case 'sca-qv-button':
                    $(e.toElement).click(function() {
                        clearInterval(swapInterval);
                        $(self).children('img').each(function(i, e) {
                            if (i === 0) {
                                this.style.display = 'inline-block';
                            } else {
                                this.style.display = 'none';
                            }
                        });
                        swapInterval = null;
                    });
                    return;
                case '':
                    return;
                default:
                    break;
            }
        }
        clearInterval(swapInterval);
        $(this).children('img').each(function(i, e) {
            if (i === 0) {
                this.style.display = 'inline-block';
            } else {
                this.style.display = 'none';
            }
        });
        swapInterval = null;
    });
}
ImageShopify.prototype.initColorVariant = function(items) {
    var hover = false;
    var noImage = false;
    var parent;
    var selector = ".item-color-swatch li";
    if (items) {
        var arrayItem = [];
        items.forEach(function(item) {
            $(item).find(".item-color-swatch li").each(function() {
                arrayItem.push(this);
            });
        });
        selector = arrayItem;
    }
    $(selector).on('mouseenter touchstart', function(e) {
        if (!hover && !parent || e.type === 'touchstart') {
            var id = $(this).find('img').attr('data-id');
            parent = $(this).parents('.grid-item');
            if (id) {
                parent.find('.grid-image img').each(function(i, e) {
                    if ($(this).attr('data-id') === id) {
                        this.style.display = 'inline-block';
                    } else {
                        this.style.display = 'none';
                    }
                });
            } else {
                var widthItem = parent.find('.grid-image img')[0].clientWidth;
                var heightItem = parent.find('.grid-image img')[0].clientHeight;
                parent.find('.grid-image img').each(function(i, e) {
                    this.style.display = 'none';
                });
                var img = $(this).find('img')[0].outerHTML;
                parent.find('.grid-image').append(img);
                parent.find('.grid-image img').last().css({
                    width: widthItem,
                    height: heightItem,
                    display: 'inline-block'
                })
                noImage = true;
            }
            hover = true;
        }
    }).on('mouseleave', function(e) {
        if (noImage) {
            parent.find('.grid-image img').last().remove();
            noImage = false;
            parent.find('.grid-image img').each(function(i, e) {
                if (i === 0) {
                    this.style.display = 'inline-block';
                } else {
                    this.style.display = 'none';
                }
            });
        }
        hover = false;
        parent = null;
    });
}
ImageShopify.prototype.initSetProductHeightLoadMore = function(index) {
    if (!index) {
        index = -1;
    }
    var row = {};
    var list = [];
    var listTop = [];
    var maxHeight = 0;
    var length = $(".tp-des-top").length;
    $(".tp-des-top").map(function(idx) {
        var parent = $(this).parents('.grid-item');
        var top = Math.round(parent.offset().top);
        if (Math.abs(top - listTop[listTop.length - 1]) < 30) {
            top = listTop[listTop.length - 1];
        }
        var height = $(this).outerHeight();
        if (row[top]) {
            if (height > row[top]) {
                row[top] = height;
                maxHeight = height;
            }
        } else {
            if (list.length > 0) {
                for (var key in list) {
                    var element = list[key];
                    $(element).css('height', maxHeight);
                }
            }
            list = [];
            row[top] = height;
            maxHeight = height;
            listTop.push(top);
        }
        list.push(this);
        if (idx === length - 1) {
            for (var key in list) {
                var element = list[key];
                $(element).css('height', maxHeight);
            }
        }
    });
}
ImageShopify.prototype.initSetProductHeight = function() {
    /*var heights = $(".tp-des-top").map(function() {
            return $(this).outerHeight();
        }).get(),
        maxHeight = Math.max.apply(null, heights);
    $(".tp-des-top").css('height', maxHeight);*/
};

/*=============================Countdown==========================*/
function CountDownShopify(){}
CountDownShopify.prototype.initAll=function(items){if(items){this.initCountDownGrid(items);}else{this.initCountDownGrid();}}
CountDownShopify.prototype.initCountDownGrid=function(items){var selector=".grid-item .tp-countdown .countdown-inner > div";if(items){var arrayItem=[];items.forEach(function(item){var selectItem=$(item).find(selector)[0];if(selectItem){arrayItem.push(selectItem);}});selector=arrayItem;} 
$(selector).each(function(index){var data=$(this).attr('data');$(this).countdown(data,function(evt){$(this).html(evt.strftime(' ' + '<span><strong>%D</strong>Days</span>' + '<span><strong>%H</strong>Hours</span>' + '<span><strong>%M</strong>Mins</span>' + '<span><strong>%S</strong>Secs</span>' ));});});}
/*==============================Cart=============================*/
function Cart() {}
Cart.prototype.initAddToCart = function(items) {
    var ajax = new Ajax();
    var self = this;
    var firstSelector = $('.add-to-cart-btn');
    if (items) {
        var arrayItem = [];
        items.forEach(function(item) {
            arrayItem.push($(item).find('.add-to-cart-btn')[0]);
        });
        firstSelector = arrayItem;
    }
    $(firstSelector).click(function(event) {
        if ($(this).attr('disabled') != 'disabled' && $(this).attr('type') === 'submit') {
            var productItem = $(this).parents('.variants');
            var productId = $(productItem).attr('id');
            productId = productId.match(/\d+/g);
            var variant_id = $('#product-actions-' + productId + ' input[name=id]').val();
            var quantity = 1;
            ajaxAddToCart(variant_id, quantity);
        }
        event.preventDefault();
        return false;
    });
    if (items) {
        return;
    }
    $('.tp-product-action .btn-addtocart').click(function(event) {
        if ($(this).attr('disabled') != 'disabled') {
            var parent = $(this).parents('form');
            var variant_id;
            if (window.addToCartVariant) {
                variant_id = window.addToCartVariant.id
                var quantity = parent.find('.tp-product-quantity .js-qty input').val();
                ajaxAddToCart(variant_id, quantity);
            }
        }
        event.preventDefault();
        return false;
    });
    $('.tp-wishlist-page .wl-add').click(function(event) {
        var form = $(this).closest('form');
        var variant_id = form.find('input[name=id]').val();
        var quantity = 1;
        ajaxAddToCart(variant_id, quantity);
        event.preventDefault();
        return false;
    });
    $('.sca-qv-cartbtn').click(function(event) {
        $(".sca-qv-cartbtn").bind("DOMSubtreeModified", function(e) {
            if ($(this).prop('disabled') === false) {
                ajax.filterAjaxClick(null, self.renderCart, function() {
                    self.initRemoveToCart();
                });
            }
        });
        return false;
    });

    function ajaxAddToCart(variant_id, quantity) {
        $.ajax({
            type: "post",
            url: "/cart/add.js",
            data: 'quantity=' + quantity + '&id=' + variant_id,
            dataType: 'json',
            beforeSend: function() {
                Ajax.showLoading();
            },
            success: function(msg) {
                ajax.filterAjaxClick(null, self.renderCart, function() {
                    self.initRemoveToCart();
                    toastr.success('Product ' + '<span style="font-weight:bold">' + msg.product_title + '</span>'  + ' was successfully added to your cart!');
                });
            },
            error: function(xhr, text) {
                toastr.error('Can&#39;t add to cart!');
                Ajax.hideLoading();
            }
        });
    };
}
Cart.prototype.initRemoveToCart = function() {
    var ajax = new Ajax();
    var self = this;
    $('.btn-remove-cart').each(function(index) {
        $(this).on('click', function(event) {
            ajaxRemoveToCart(index + 1);
            event.preventDefault();
        })
    })

    function ajaxRemoveToCart(line) {
        $.ajax({
            type: "post",
            url: "/cart/change.js",
            data: 'quantity=0&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                Ajax.showLoading();
            },
            success: function(msg) {
                ajax.filterAjaxClick(null, self.renderCart, function() {
                    self.initRemoveToCart();
                    toastr.success('Product was successfully removed from your cart!');
                });
            },
            error: function(xhr, text) {
                toastr.error('Can&#39;t remove to cart!');
                Ajax.hideLoading();
            }
        });
    };
}
Cart.prototype.renderCart = function(data, callback) {
    var currentCart, newCart;
    currentCart = $(".site-header-cart");
    newCart = $(data).find(".site-header-cart");
    currentCart.replaceWith(newCart);
    if (callback) {
        callback();
    }
}
/*================================Wishlist=============================*/
function Wishlist() {
    this.ajax = new Ajax();
}


Wishlist.prototype.initWishlistSaveProductId = function () {
    $(".tp-wishlist").click(function() {

        $('.loader').show();
        var nt_wishlist_product_id = $(this).data('handle');
        var nt_wishlist_array = [];
        if(jQuery.cookie('tp-wishlist-product-id')) {
            nt_wishlist_array = jQuery.cookie('tp-wishlist-product-id')
            nt_wishlist_array = JSON.parse(nt_wishlist_array);
            var nt_wishlist_index = nt_wishlist_array.indexOf(nt_wishlist_product_id);
            if(nt_wishlist_index == -1){
                nt_wishlist_array.push(nt_wishlist_product_id)
            }
            jQuery.cookie('tp-wishlist-product-id', JSON.stringify(nt_wishlist_array), {expires:7, path:'/'});
        }else {
            nt_wishlist_array.push(nt_wishlist_product_id);
            jQuery.cookie('tp-wishlist-product-id', JSON.stringify(nt_wishlist_array), {expires:7, path:'/'});
        }
        console.log(jQuery.cookie('tp-wishlist-product-id'));

        toastr.success('<span style="font-weight:bold">' + $(this).attr( "data-name" ) + '</span>' + 'was successfully added to your' + '<a href="/pages/wishlists">' + 'Wishlist' + '</a>!');

        $(this).addClass('checked-wishlist');

        setTimeout(function(){
            $('.loader').hide();
        }, 500);

    })
}

Wishlist.prototype.initWishlistChecked = function () {

    if(jQuery.cookie('tp-wishlist-product-id')){
        var nt_wishlist_array = jQuery.cookie('tp-wishlist-product-id')
        nt_wishlist_array = JSON.parse(nt_wishlist_array);
        jQuery('a.tp-wishlist').each(function(){
            var nt_wishlist_handle = $(this).data('handle')
            var nt_wishlist_index = nt_wishlist_array.indexOf(nt_wishlist_handle);
            if(nt_wishlist_index >= 0){
                $(this).addClass('checked-wishlist');
            }
        })
    }

}
/*=====================================Compare===================================*/
function Compare() {
    this.ajax = new Ajax();
}

Compare.prototype.initCompareSaveProductId = function () {
    $(".tp-compare").click(function() {
        $('.loader').show();

        var nt_compare_product_id = $(this).data('handle');
        var nt_compare_array = [];
        if(jQuery.cookie('tp-compare-product-id')) {
            nt_compare_array = jQuery.cookie('tp-compare-product-id')
            nt_compare_array = JSON.parse(nt_compare_array);
            var nt_compare_index = nt_compare_array.indexOf(nt_compare_product_id);
            if(nt_compare_index == -1){
                nt_compare_array.push(nt_compare_product_id)
            }

            jQuery.cookie('tp-compare-product-id', JSON.stringify(nt_compare_array), {expires:7, path:'/'});
        }else {
            nt_compare_array.push(nt_compare_product_id);
            jQuery.cookie('tp-compare-product-id', JSON.stringify(nt_compare_array), {expires:7, path:'/'});
        }
        //console.log(jQuery.cookie('tp-compare-product-id'));

        toastr.success('<span style="font-weight:bold">' + $(this).attr( "data-name" ) + ' </span>' + 'was successfully added to your' + '<a href="/pages/compare">' + 'Compare' + '</a>!');

        $(this).addClass('checked-compare');

        setTimeout(function(){

            $('.loader').hide();
        }, 500);

    })
}

Compare.prototype.initCompareChecked = function () {

    if(jQuery.cookie('tp-compare-product-id')){
        var nt_compare_array = jQuery.cookie('tp-compare-product-id')
        nt_compare_array = JSON.parse(nt_compare_array);
        jQuery('a.tp-compare').each(function(){
            var nt_compare_handle = $(this).data('handle')
            var nt_compare_index = nt_compare_array.indexOf(nt_compare_handle);
            if(nt_compare_index >= 0){
                $(this).addClass('checked-compare');
            }
        })
    }

}
/*===================================Filter=======================================*/
function Filter() {
    this.ajax = new Ajax();
}
Filter.prototype.initAll = function () {
    this.initPagination();
    this.initSortBy();
    this.initView();
    this.initProductTag();
}
Filter.prototype.initPagination = function () {
    var self = this;
    $(".tp-collection-content .pagination span a").click(function (e) {
        var href = $(this).attr("href");
        var page = href.match(/page=\d+/g);
        if ($('.tp-collection-content>section').length > 0) {
            var targetList = $('.tp-collection-content>section').offset().top - 100;
        }
        else {
            var targetList = $('.main-content').offset().top;
        }
        
        if (page) {
            Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
            if (Shopify.queryParams.page) {
                var newurl = self.ajax.filterCreateUrl();
                history.pushState({
                    param: Shopify.queryParams
                }, newurl, newurl);
                self.ajax.loadData(newurl, self.renderProductList.bind(self));
            }
            $("body,html").animate({
              scrollTop: targetList
            }, 600);
        }
        e.preventDefault();
    });
}
Filter.prototype.initCurrency =  function () {
    var shopCurrency = $('.select-currency li:first-child').data('currency');
    var newCurrency =  $('.select-currency li.selected').data('currency');
    if (shopCurrency || newCurrency) {
        if (shopCurrency != newCurrency) {
          // Add precalculated shop currency to data attribute 
          $('span.money').each(function() {
            $(this).attr('data-currency-' + shopCurrency, jQuery(this).html());
          });
          Currency.convertAll(shopCurrency, newCurrency); 
        }
    }
}
Filter.prototype.initSortBy = function () {
    var self = this;
    
    $(".tp-collection-sort .dropdown-menu li").click(function(){
        if (!$(this).hasClass("active")) {
            Shopify.queryParams.sort_by = $(this).attr("data-value");
            self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));
            var sortbyText = $(this).text();
            $(".tp-collection-sort .dropdown-toggle").text(sortbyText);
            $(".tp-collection-sort .dropdown-menu li.active").removeClass("active");
            $(this).addClass("active");
        }
    });
}
Filter.prototype.initView = function () {
    var self = this;
    $(".collection-view button").click(function (e) {
        if (!$(this).hasClass(".change-view--active")) {
            var paging = $(".pagination .page.current").html();
            Shopify.queryParams.view = $(this).attr('data-view');
            self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));
        }
        e.preventDefault();
    });
}
Filter.prototype.initProductTag = function () {
    var self = this;
    $(".tp-filter-block .tp-filter-content input").click(function (e) {
        var currentTags = [];
        if (Shopify.queryParams.constraint) {
            currentTags = Shopify.queryParams.constraint.split('+');
        }
        var parent = $(this).parents('.tp-filter-block');
        var valueOldTag = parent.find('input[checked]').val();
        var value = $(this).parent().find('input').val();
        var tagPosition = currentTags.indexOf(value);
        if (tagPosition >= 0) {
            currentTags.splice(tagPosition, 1);
        } else {
            currentTags.push(value);
        }
        var oldTagPosition = currentTags.indexOf(valueOldTag);
        if (oldTagPosition >= 0) {
            currentTags.splice(oldTagPosition, 1);
        }
        if (currentTags.length) {
            Shopify.queryParams.constraint = currentTags.join('+');
        } else {
            delete Shopify.queryParams.constraint;
        }
        self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));
        e.preventDefault();
    });
    if ($(".tp-sidebar-collection .tp-filter-block").length > 0 && Shopify.queryParams.constraint) {
        var last_filter_block = $(".tp-sidebar-collection .tp-filter-block").last();
        $("<div class='reset-filter'>Reset All Filter</div>").insertAfter(last_filter_block);
    };
    $(".tp-sidebar-collection .reset-filter").click(function (e) {
        delete Shopify.queryParams.constraint;
        self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));
        e.preventDefault();
    });
}
Filter.prototype.initViewMoreTagsBlock = function () {
    var ul = $('.block-tags .tp-sidebar-content ul');
    var height_ul = ul.height();
    if (height_ul > 230){
        ul.attr('style', 'height: 230px; overflow: hidden;')
        ul.parent().append('<a href="#" class="more-tags">' + 'View more' + '</a>');

        $('a.more-tags').click(function (e) {
            e.preventDefault();
            if ($(this).text() == 'View more') {
                ul.removeAttr('style')
                $(this).text('View less')
                return;
            } else if ($(this).text() == 'View less') {
                ul.attr('style', 'height: 230px; overflow: hidden;')
                $(this).text('View more')
            }
        });
    };
}
Filter.prototype.initLoadMore = function (className) {
    window.ias = jQuery.ias({
        container: '.' + className,
        item: '.grid-item',
        pagination: '.' + className + ' .pagination',
        next: '.next a'
    });
    
    window.ias.extension(new IASSpinnerExtension({}));
    window.ias.extension(new IASNoneLeftExtension({text: 'There are no more pages left to load.'}));
    
    window.ias.on('rendered', function (items) {
        var imageShopify = new ImageShopify();
        imageShopify.initImageConfigure(items);
        var countDownShopify = new CountDownShopify();
        countDownShopify.initAll(items);
        var cart = new Cart();
        cart.initAddToCart(items);
        var wishlist = new Wishlist(); 
        wishlist.initWishlist(); 
        var compare = new Compare(); 
        compare.initCompare();
        var currentClassName = $(".tp-collection-content > section")[0].className;
        setTimeout(function () {
            if(currentClassName === 'tp-product-grid'){
                imageShopify.initSetProductHeightLoadMore(itemLength - 1);
            }else{
                imageShopify.initSetProductHeight();
            }
        }, 420);
    })

    var itemLength = 0;
    window.ias.on('render', function () {
        itemLength = $(".tp-des-top").length; 
    })
}
Filter.prototype.renderProductList = function (data, callback) {
    var classNameCurrentList = $(".tp-collection-content > section")[0].className;
    var classNameNewList = $(data).find(".tp-collection-content > section")[0].className;
    var currentList = $(".tp-collection-content ." + classNameCurrentList);
    var newList = $(data).find(".tp-collection-content ." + classNameNewList);
    currentList.toggleClass(classNameCurrentList, classNameNewList);
    currentList.replaceWith(newList);
    var currentPaging = $(".tp-collection-content .tp-pagination-bottom .pagination");
    var newPaging = $(data).find(".tp-collection-content .tp-pagination-bottom .pagination");
    if (currentPaging.length > 0) {
        if (newPaging.length > 0) {
            currentPaging.replaceWith(newPaging);
        } else {
            currentPaging.remove();
        }
    } else {
        if (newPaging.length > 0) {
            $(".tp-collection-content .tp-pagination-bottom").append(newPaging); 
        }
    }
    this.initPagination();
    var currentSortByToolbar = $(".tp-collection-toolbar #SortBy");
    var newPageSortByToolbar = $(data).find(".tp-collection-toolbar #SortBy");
    currentSortByToolbar.replaceWith(newPageSortByToolbar);
    this.initSortBy();
    var currentViewToolbar = $(".tp-collection-toolbar .collection-view");
    var newPageViewToolbar = $(data).find(".tp-collection-toolbar .collection-view");
    currentViewToolbar.replaceWith(newPageViewToolbar);
    this.initView();
    var currentTagFilter = $('.tp-collection-filter');
    var newTagFilter = $(data).find('.tp-collection-filter');
    currentTagFilter.replaceWith(newTagFilter);
    this.initProductTag();
    var currentTagsBlock = $('.block-tags');
    var newTagsBlock = $(data).find('.block-tags');
    currentTagsBlock.replaceWith(newTagsBlock);
    this.initViewMoreTagsBlock();
    var countDownShopify = new CountDownShopify();
    countDownShopify.initAll();
    var imageShopify = new ImageShopify();
    imageShopify.initImageConfigure();
    imageShopify.initSetProductHeight();
    var cart = new Cart();
    cart.initAddToCart();
    
   
    if (window.ias) {
        window.ias.reinitialize();
        window.ias.itemsContainerSelector = '.' + classNameNewList;
        window.ias.paginationSelector = '.' + classNameNewList + ' .pagination';
        if (window.iasTrigger && window.iasTrigger.$triggerNext) {
            window.iasTrigger.$triggerNext.remove();
            window.iasTrigger.$triggerNext = null;
        }
    }
}
/*============================Scroll Homepage=========================*/
function InfiniteScroll(){this.ajax=new Ajax();}
InfiniteScroll.prototype.initLoadMore=function(className){window.ias=jQuery.ias({container:'.'+className,item:'.grid-item',pagination:'.'+className+' .pagination',next:'.next a'});window.ias.extension(new IASSpinnerExtension({}));var itemLength=0;window.ias.on('render',function(){itemLength=$(".tp-des-top").length;})
window.ias.on('rendered',function(items){var imageShopify=new ImageShopify();imageShopify.initImageConfigure(items);var countDownShopify=new CountDownShopify();countDownShopify.initAll(items);var cart=new Cart();cart.initAddToCart(items);var currentClassName=$(".tp-product-grid");setTimeout(function(){if(currentClassName==='tp-product-grid'){imageShopify.initSetProductHeightLoadMore(itemLength-1);}else{imageShopify.initSetProductHeight();}},420);})}